/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class AccountChatbotFormDialog extends NoboxEntityDialog<AccountRow, any> {
        protected getFormKey() { return AccountChatbotForm.formKey; }
        protected getIdProperty() { return AccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRow.localTextPrefix; }
        protected getService() { return AccountService.baseUrl; }
        protected getDeletePermission() { return AccountRow.deletePermission; }
        protected getInsertPermission() { return AccountRow.insertPermission; }
        protected getUpdatePermission() { return AccountRow.updatePermission; }

        protected form = new AccountChatbotForm(this.idPrefix);
        public setTemplate = (account: AccountRow) => { };

        private btnMessageCount: number = 0;
        private btnActionCount: number = 0;
        constructor(container?: JQuery) {
            super(container);
            this.form.AccountId.change(() => {
                var val = this.form.AccountId.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    AccountService.Retrieve({ EntityId: val }, (res) => {
                        var item = res.Entity;
                        Serenity.EditorUtils.setValue(this.form.BotActive, item.BotActive);
                        Serenity.EditorUtils.setValue(this.form.BotChannel, item.BotChannel);
                        Serenity.EditorUtils.setValue(this.form.BotEndpoint, item.BotEndpoint);
                        Serenity.EditorUtils.setValue(this.form.BotEngine, item.BotEngine);
                        Serenity.EditorUtils.setValue(this.form.BotName, item.BotName);
                        Serenity.EditorUtils.setValue(this.form.BotOptions, item.BotOptions);
                        Serenity.EditorUtils.setValue(this.form.BotPassword, item.BotPassword);
                        Serenity.EditorUtils.setValue(this.form.BotUsername, item.BotUsername);
                    });
                } else {
                    Serenity.EditorUtils.setValue(this.form.BotActive, 0);
                    Serenity.EditorUtils.setValue(this.form.BotChannel, null);
                    Serenity.EditorUtils.setValue(this.form.BotEndpoint, null);
                    Serenity.EditorUtils.setValue(this.form.BotEngine, null);
                    Serenity.EditorUtils.setValue(this.form.BotName, null);
                    Serenity.EditorUtils.setValue(this.form.BotOptions, null);
                    Serenity.EditorUtils.setValue(this.form.BotPassword, null);
                    Serenity.EditorUtils.setValue(this.form.BotUsername, null);
                }
            });
        }

        protected updateInterface() {
            super.updateInterface();
        }

        protected getDialogTitle() {
            return "Import Setting AI Chatbot";
        }

        protected getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Import Setting",
                icon: "fa-check text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        this.setTemplate(this.getSaveEntity());
                        this.dialogClose();
                    }
                }
            });
            return buttons;
        }
    }
}